import { TextMatchTransformer } from "@lexical/markdown";
import { LexicalNode, TextNode } from "lexical";
import {
  autotextRegex,
  dataRequestToMarkdown,
  dataRequestTypes,
  markdownToDataRequest,
} from "@/ai/autotext";
import { logDebug } from "@/utils/log";
import { $createDCVariableNode, DCVariableNode } from "./DCVariableNode";

export const DCVariableTransformer: TextMatchTransformer = {
  type: "text-match",
  dependencies: [DCVariableNode],
  regExp: autotextRegex,
  importRegExp: autotextRegex,

  export: (node: LexicalNode): string | null => {
    if (node instanceof DCVariableNode) {
      return dataRequestToMarkdown(node.exportJSON().data);
    } else {
      return null;
    }
  },

  replace: (textNode: TextNode, match: RegExpMatchArray) => {
    const [str, name] = match;
    if ((dataRequestTypes as string[]).includes(name)) {
      const variableNode = $createDCVariableNode(markdownToDataRequest(str));
      textNode.replace(variableNode);
    } else {
      logDebug(`Unsupported variable: ${str}`);
    }
  },
};
